import { URLParams } from 'modules/url-params/state/app-url-params-types'
import {
  OrderRecurringEndDateSlice,
  OrderRecurringEndDateValue,
} from './order-recurring-end-date-types'

const DEFAULT_RECURRING_END_DATE: OrderRecurringEndDateValue = undefined

export const makeOrderRecurringEndDateInitialState = (
  urlParams: URLParams,
): OrderRecurringEndDateSlice => {
  const value = urlParams.recurringEndDate

  // url param null becomes redux state value undefined
  return { value: value || DEFAULT_RECURRING_END_DATE }
}
